<template>
  <div
    class="vitality_big_multi"
    v-if="banner_list.length"
  >
    <img
      v-if="info.titleurl"
      class="title_img mb8 radius-8px"
      :src="info.titleurl"
      alt=""
      @error="onTitleImgError"
    />

    <div class="body_row" :style="section_style">
      <div class="left_nav">
        <div
          v-for="(item, index) of banner_list"
          :key="'nav-' + index"
          class="nav_item"
          :class="{ nav_item_active: active_index === index }"
          @click.stop="onNavClick(index)"
        >
          <img
            class="nav_thumb radius-8px"
            :src="main_src(item)"
            :alt="item.ad_title || ''"
            @error="onImgError"
          />
        </div>
      </div>

      <div class="right_panel">
        <swiper
          ref="vitalitySwiper"
          class="vitality_swiper"
          :options="swiper_option_computed"
        >
          <swiper-slide
            v-for="(item, index) of banner_list"
            :key="'slide-' + index"
            class="main_slide"
          >
            <div class="main_slide_inner">
              <img
                class="main_img radius-8px"
                :src="thumb_src(item)"
                :alt="item.ad_title || ''"
                @error="onImgError"
              />
              <div
                :path="
                  (item.ad_target || '') +
                  (String(item.ad_target || '').indexOf('?') >= 0 ? '&' : '?') +
                  'sorce=8'
                "
                :username="'gh_5d4bb8e18b8b'"
                class="slide_cl_xcx"
                v-if="is_wx && (item.ad_type == 7 || item.ad_type == 8)"
              ></div>
            </div>
          </swiper-slide>
        </swiper>
      </div>
    </div>
  </div>
</template>

<script>
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.min.css'
import { isWeixin, checkAgent } from '../../../assets/common/js/config'

/**
 * 接口 bigMultiBannerZone[] 单项结构（与 homepage/json/ajax.js 一致）：
 * - 区块：titleurl, bgimg, bannerList
 * - bannerList[]：mainImg, ad_title, img_path, ad_type, ad_target, roomid, liveid,
 *   liveroom_qrcode_url, height, width, finderUserName
 */
export default {
  name: 'vitalityBigMultiBanner',
  components: {
    swiper: VueAwesomeSwiper.swiper,
    swiperSlide: VueAwesomeSwiper.swiperSlide
  },
  props: {
    info: {
      type: Object,
      default: () => ({})
    },
    /** 埋点 flowArea 前缀，如 bigMultiBannerZone */
    flow_area_prefix: {
      type: String,
      default: 'bigMultiBannerZone'
    },
    compIndex: {
      type: Number,
      default: 0
    },
  },
  data() {
    return {
      active_index: 0,
      is_wx: isWeixin() ? 1 : 0
    }
  },
  computed: {
    banner_list() {
      const list = this.info.bannerList || this.info.banner_list
      return Array.isArray(list) ? list : []
    },
    section_style() {
      const bg = this.info.bgimg
      if (!bg) return {}
      return {
        background: `url(${bg}) center top / 100% 100% no-repeat`
      }
    },
    swiper_option_computed() {
      var that = this
      const n = this.banner_list.length
      const multi = n > 1
      return {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: multi,
        autoplay: multi
          ? {
              delay: 5000,
              disableOnInteraction: false
            }
          : false,
        observer: true,
        observeParents: true,
        on: {
          slideChangeTransitionEnd: function () {
            that.active_index = multi ? this.realIndex : this.activeIndex
          },
          click: function () {
            var idx = multi ? this.realIndex : this.clickedIndex
            if (idx === undefined || idx < 0) return
            var list = that.banner_list
            if (!list || idx >= list.length) return
            if (checkAgent() != 'Harmony') {
              that.$emit('banner-click', list[idx], idx, that.flow_area_prefix +'-' + (idx + 1))
            }
          }
        }
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.swiperClickHandler(this.compIndex)
    })
  },
  methods: {
    // swiper点击兼容鸿蒙系统
    swiperClickHandler(compIndex) {
      if (!this.banner_list.length || !this.$refs.vitalitySwiper[compIndex]) return
      const swiperEl = this.$refs.vitalitySwiper[compIndex].$el
      const eventType = checkAgent() == 'Harmony' ? 'click' : ''
      if (eventType) {
        swiperEl.addEventListener(eventType, (e) => {
          e.stopPropagation()
          const slideItem = e.target.closest('.swiper-slide')
          if (slideItem) {
            const id = slideItem.dataset.swiperSlideIndex
              ? parseInt(slideItem.dataset.swiperSlideIndex || 0)
              : parseInt(slideItem.getAttribute('data-swiper-slide-index') || 0)
            this.$emit('banner-click', this.banner_list[id], id, this.flow_area_prefix + '-' + (id + 1))
          }
        })
      }
    },
    /** 左侧缩略图：优先列表图  mainimg */
    main_src(item) {
      return item.mainimg || '/static/images/errorimg.jpg'
    },
    /** 右侧大图：优先 img_path */
    thumb_src(item) {
      return item.img_path || '/static/images/errorimg.jpg'
    },
    onImgError(e) {
      const img = e.target
      img.src = '/static/images/errorimg.jpg'
      img.onerror = null
    },
    onTitleImgError(e) {
      const img = e.target
      img.style.display = 'none'
      img.onerror = null
    },
    onNavClick(index) {
      this.active_index = index
      const comp = this.$refs.vitalitySwiper
      if (!comp || !comp.swiper) return
      const sw = comp.swiper
      const n = this.banner_list.length
      if (n <= 1) {
        sw.slideTo(0, 300, false)
        return
      }
      sw.slideToLoop(index, 300, false)
    }
  }
}
</script>

<style scoped lang="scss">
.vitality_big_multi {
  margin: 0.1rem 0.11rem 0;
  overflow: hidden;
}

.title_img {
  display: block;
  width: 100%;
  height: auto;
}

.body_row {
  display: flex;
  align-items: stretch;
  padding: 0.1rem;
}

.left_nav {
  flex: 0 0 29.2%;
  max-width: 29.2%;
  display: flex;
  flex-direction: column;
  gap: 0.1rem;
  padding-right: 0.1rem;
}

.nav_item {
  position: relative;
  overflow: hidden;

  &.nav_item_active::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.25);
    z-index: 1;
  }
}

.nav_thumb {
  display: block;
  width: 100%;
  height: 1.24rem;
}

.right_panel {
  flex: 1;
  min-width: 0;
  position: relative;
}

.vitality_swiper {
  overflow: hidden;
  height: 4rem;
}

.main_slide {
  height: 100%;
}

.main_slide_inner {
  position: relative;
  display: block;
  height: 100%;
  overflow: hidden;
}

.main_img {
  display: block;
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/homepage/components/vitalityBigMultiBanner.vue